export const DOCS_LINK = 'https://docs.smartsupp.com/chat-box/'
export const DOCS_LANGUAGES_LINK = `${DOCS_LINK}localization/#supported-languages`
export const DOCS_CUSTOM_VISITOR_DATA_LINK = `${DOCS_LINK}visitor-identification/#custom-visitor-data`
export const DOCS_CUSTOM_VISITOR_CONTACT_DATA_LINK = `${DOCS_LINK}visitor-identification/#custom-contact-data`
export const DOCS_EVENTS_LINK = `${DOCS_LINK}javascript-api/events/`
export const HELP_COOKIE_CONSENT_LINK =
	'https://www.smartsupp.com/help/cookie-consent/#where-to-enable-cookie-consent-in-smartsupp'
export const PRICING_LINK = 'https://www.smartsupp.com/pricing'
